var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6668 18.9935L38.8301 60.8668L23.2834 45.3202L28.4535 40.1502L38.8301 50.5268L75.4968 13.8602L80.6668 18.9935ZM72.5635 37.4735C73.0401 39.5635 73.3335 41.7635 73.3335 44.0002C73.3335 60.2068 60.2068 73.3335 44.0001 73.3335C27.7934 73.3335 14.6668 60.2068 14.6668 44.0002C14.6668 27.7935 27.7934 14.6668 44.0001 14.6668C49.7934 14.6668 55.1468 16.3535 59.6935 19.2502L64.9734 13.9702C59.0334 9.79016 51.8101 7.3335 44.0001 7.3335C23.7601 7.3335 7.33345 23.7602 7.33345 44.0002C7.33345 64.2402 23.7601 80.6668 44.0001 80.6668C64.2401 80.6668 80.6668 64.2402 80.6668 44.0002C80.6668 39.6368 79.8601 35.4568 78.4668 31.5702L72.5635 37.4735Z",
    fill: "#00D186"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success_tick.4d420326a3df9e1c1756630112d8cc29.svg";
export { ForwardRef as ReactComponent };